(function () {
  'use strict';

  angular
    .module('sepa')
    .factory('SepaService', SepaService);

  function SepaService($log, $q, $http, EndpointsService) {

    var SepaServiceBase = {};

    SepaServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        //$log.debug("Params:", params);
        $http.get(response.links.sepaDD, {
          params: params
        }).success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.sepaDD_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getSepaSettings = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.sepaDDSettings, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getSepaDDComplaints = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.sepaDDComplaint, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getSepaSettingsById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.sepaDDSettings_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.addSepaSetting = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
      $http.post(response.links.sepaDDSettings, data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };


    SepaServiceBase.addSepaDDComplaint = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
      $http.post(response.links.sepaDDComplaint, data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.deactivateSepaSetting = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
      $http.put(response.links.sepaDDSettings_deactivate, data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.signSepaComplaint = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
      $http.put(response.links.sepaDDComplaint_sign, data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.signSepaSetting = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
      $http.put(response.links.sepaDDSettings_sign, data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.updateSepaSetting = function(id, data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.sepaDDSettings_id.replace('{id}', id), data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getSepaSettingsTypes = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.sepaDDSettingsTypes, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getSepaSettingsTypesByAccountId = function (id, params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links["sepaDDSettings_settingTypesList?accountId={accountId}"].replace('{accountId}', id), {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getSepaCreditorsList = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.sepaDDSettings_creditorsList, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getSepaDDSettingsExecutionPeriodTypes = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.sepaDDSettings_executionPeriodTypes, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };


    SepaServiceBase.getSepaDDComplaintReasonTypes = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        //$log.debug("Params:", params);
        $http.get(response.links.sepaDDComplaintReasonTypes, {
          params: params
        }).success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    return SepaServiceBase;
  }
}());
